export const FUEL_ESCALATOR_COLUMN_LIST = [
    {name:'Selected', label:"Selected", selected: false, ScreenColumnID: 0, ScreenID: 0, orderId:0},
    { name: "Status", label: "Status", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:1 },
    { name: "FuelEscalatorID", label: "Escalator ID", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:2 },
    { name: "FuelEscalatorEffectiveDate", label: "Effective Date", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:3 },
    { name: "FuelEscalatorDescription", label: "Description", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:4 },
    { name: "CreatedOn", label: "Created (Date/Time)", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:5 },
    { name: "ModifiedOn", label: "Modified (Date/Time)", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:6 },
    {name:'action', label:"action", selected: false, ScreenColumnID: 0, ScreenID: 0, orderId:0},
];

export const FUEL_PRICE_RATE_COLUMN_LIST = [
    {name:'Selected', label:"Selected", selected: false, orderId:0},
    { name: "CountryofFuelIndex", label: "Country", selected: true, orderId:1 },
    { name: "IncludeTax", label: "Including Taxes", selected: true, orderId:2 },
    { name: "EscalatorValue", label: "Index Value", selected: true,orderId:3 },
]

